import React from 'react';
import Loadable from '@caixue/react-loadable';
import { Loading } from 'components';

export default Loadable({
  loader: () => import('./index'),
  loading: () => <Loading withContentWrapper />,
});

export const Form = Loadable({
  loader: () => import('./FormPage'),
  loading: () => <Loading withContentWrapper />,
});

export const List = Loadable({
  loader: () => import('./TenantsList'),
  loading: () => <Loading withContentWrapper />,
});

export const Features = Loadable({
  loader: () => import('./FeaturesPage'),
  loading: () => <Loading withContentWrapper />,
});

export const Theme = Loadable({
  loader: () => import('./TenantThemePage'),
  loading: () => <Loading withContentWrapper />,
});

export const BulkUpdate = Loadable({
  loader: () => import('./BulkUpdatePage'),
  loading: () => <Loading withContentWrapper />,
});
